import React from 'react';
import BetelgeuseMixin from 'js/mixins/betelgeuse';
import SearchInput from 'jsx/components/search/searchInput';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

const ErrorPage = createReactClass({
  propTypes: {
    redirect: PropTypes.object,
    subTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
  },

  mixins: [BetelgeuseMixin],

  getDefaultProps() {
    return {
      title: i18n('Oops. Looks like that page no longer exists!'),
      subTitle: i18n('Try a search'),
    };
  },

  render() {
    return (
      <div className="sitecontainer-body sitecontainer-body-padded">
        <div className="row error-page">
          <div className="col-sm-8 col-sm-offset-2">
            <h1 className="main-title">{this.props.title}</h1>
            {
              this.props.redirect &&
              <div className="sub-title redirect-sub-title">
                <a href={'/' + this.props.redirect.link}>{this.props.redirect.message}</a>
              </div>
            }
            <h2 className="sub-title">{this.props.redirect ? i18n('Or try a search') : this.props.subTitle}</h2>
            <div className="search-header">
              <SearchInput
                className="search-bar__container--center"
              />
            </div>
          </div>
        </div>
      </div>
    );
  },
});

module.exports = ErrorPage;



// WEBPACK FOOTER //
// ./app/assets/jsx/pages/error.jsx